
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faStar, faUsers, faXmark, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';
import { Link } from "react-router-dom"

//FILE UPLOAD
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

function LoanOffer({ loan }) {
    const { user } = useUser();
    const [modalIsOpen, setIsOpen] = useState(false);
    const [disable, setDisable] = useState(true);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [title, setTitle] = useState(loan.title);
    const [min, setMin] = useState(loan.min);
    const [max, setMax] = useState(loan.max);
    const [lrate, setLrate] = useState(loan.rate);
    const [duration, setDuration] = useState(loan.duration);
    const [files, setFiles] = useState([]);
    const [description, setDescription] = useState(loan.descr);
    const [file_name, setFile_name] = useState(loan.photo);
    const [rate, setRate] = useState(1);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    useEffect(() => {
        if(file_name && title && min && max && duration && lrate && description){
            setDisable(false);
        }else{
            setDisable(true);
        }
    }, [file_name, title, min, max, duration, lrate, description]);
    const DeleteLoanOffer = () =>{
        setLoading2(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/loan.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_deleteoffer: true, loan_id : loan.loan_id})
        })
        .then(response => response.json())
        .then(data => {
        if (data.status === "success") {
            toast.success(data.result);
            setTimeout(() => {
            window.location.href = "getloan";
            }, 2000);
        }else{
            toast.error(data.message);
        }
            setLoading2(false);
        })
        .catch(err => {
            console.error(err)
            setLoading2(false);
        })
    }
    const EditLoanOffer = () =>{
        setLoading1(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/loan.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ btn_editoffer: true, file_name : file_name, title : title, min : min, max : max, rate : lrate, duration : duration, description : description, loan_id : loan.loan_id})
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              setTimeout(() => {
                window.location.href = "getloan";
              }, 2000);
            }else{
              toast.error(data.message);
            }
            setLoading1(false);
        })
        .catch(err => {
            console.error(err)
            setLoading1(false);
        })
    }
    console.log(loan)
    return (
        <div className="mycard shadow p-3 position-relative">
            {user?.user_type === "adminface" && (
                <p className="text-prime fw-semibold position-absolute mb-0" onClick={() => setIsOpen(true)} style={{cursor: 'pointer', fontSize:'14px',bottom:'20px',left:'20px'}}>Edit</p>
            )}
            <div className="d-flex" style={{gap:'20px'}}>
                <div className="d-flex align-items-cenetr jusitfy-content-center overflow-hidden rounded-circle" style={{height:'35px',width:'35px',minHeight:'35px',minWidth:'35px'}}>
                    <img src={`/uploads/${loan.photo}`} alt="profile" className="w-100 h-100" style={{objectFit: 'cover'}}/>
                </div>
                <div className="flex-grow-1">
                    <p className="mb-0 fw-bold text-prime" style={{fontSize:'14px'}}>{loan.title}</p>
                    <p className="mb-0" style={{fontSize:'12px',lineHeight:'120%'}}>{loan.descr}</p>
                    <div className="d-flex align-items-center justify-content-between mt-2">
                        <p className="mb-0 fw-bold text-success" style={{fontSize:'12px'}}>Up to {getCurrencySymbol(user?.currency)}{formatCurrency(loan.max * rate)}</p>
                        <p className="mb-0 text-prime" style={{fontSize:'12px'}}>Starting from {loan.rate}%</p>
                    </div> 
                </div>
            </div>
            <div className="d-flex justify-content-end mt-2">
            { Number(user?.credit_score) > 740 ?
                (
                <Link to="/loanform" state={{loan_id: loan.loan_id,casset: 'Bitcoin', collateral: 0, collat : 'BTC'}} className="myBtn rounded-pill px-3 py-2 fw-semibold text-center" style={{fontSize:'12px'}}>Get Loan <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '10px'}} /></Link>
                ) : (  
                <Link to="/loandetails"
                onClick={() => {
                    localStorage.setItem('deposit.loanID', loan.loan_id);
                    localStorage.setItem('deposit.takeLoan', true);
                }}
                className="myBtn rounded-pill px-3 py-2 fw-semibold text-center" style={{fontSize:'12px'}}>Get Loan <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '10px'}} /></Link> 
                )
            }
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setIsOpen(false)}
                shouldCloseOnOverlayClick={true} 
                closeTimeoutMS={100}
                className="shortmode"
            >
                <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>
                    Edit Loan Type</p>
                    <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
                </div>
                <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Photo</label>
                <FilePond
                    files={files}
                    onupdatefiles={setFiles}
                    allowMultiple={false}
                    maxFiles={3}
                    name="file"
                    labelIdle="Click here to upload payment proof"
                    server={{
                    process: (fieldName, file, metadata, load, error, progress, abort) => {
                        const formData = new FormData();
                        formData.append("file", file);
                        const request = new XMLHttpRequest();
                        request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload.php`);
                        request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                        };
                        request.onload = () => {
                        const res = JSON.parse(request.responseText);
                        if (res.success) {
                            setFile_name(res.filename);
                            load(res.filename);
                        } else {
                            error(res.error || "Upload failed");
                        }
                        };
                        request.onerror = () => {
                        error("Upload error");
                        };
                        request.send(formData);
                        return {
                        abort: () => {
                            request.abort();
                            abort();
                        }
                        };
                    },
                    revert: (serverId, load, error) => {
                        fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({ filename: file_name })
                        })
                        .then((res) => res.json())
                        .then((data) => {
                            if (data.success) {
                            setFile_name(loan.photo);
                            setFiles([]);
                            load();
                            } else {
                            error(data.error || "Failed to delete file");
                            }
                        })
                        .catch(() => {
                            error("Delete request failed");
                        });
                    }
                    }}
                />
                <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Title:</label>
                <div className="form-control py-2">
                    <input 
                        type="text"
                        placeholder=""
                        className="inputNone"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                </div>
                <div className="row">
                    <div className="col-6">
                    <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Min Amount:</label>
                    <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                        <input 
                            type="number"
                            placeholder="1000"
                            className="inputNone"
                            value={min}
                            onChange={(e) => setMin(e.target.value)}
                        />
                        <div
                            className="fw-bold text-white d-flex align-items-center"
                            style={{
                            backgroundColor: 'rgb(30, 33, 36)',
                            borderRadius: '4px',
                            padding: '6px',
                            fontSize: '14px',
                            cursor: 'pointer' 
                            }}
                        >
                        USD
                        </div>
                    </div>
                    </div>
                    <div className="col-6">
                    <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Maximum Amount:</label>
                    <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                        <input 
                            type="number"
                            placeholder="1000"
                            className="inputNone"
                            value={max}
                            onChange={(e) => setMax(e.target.value)}
                        />
                        <div
                            className="fw-bold text-white d-flex align-items-center"
                            style={{
                            backgroundColor: 'rgb(30, 33, 36)',
                            borderRadius: '4px',
                            padding: '6px',
                            fontSize: '14px',
                            cursor: 'pointer' 
                            }}
                        >
                        USD
                        </div>
                    </div>
                    </div>
                </div>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Rate:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                        type="number"
                        placeholder="40"
                        className="inputNone"
                        value={lrate}
                        onChange={(e) => setLrate(e.target.value)}
                    />
                    <div
                        className="fw-bold text-white d-flex align-items-center"
                        style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                        }}
                    >
                        %
                    </div>
                </div>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Duration:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                        type="number"
                        placeholder="6"
                        className="inputNone"
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                    />
                    <div
                        className="fw-bold text-white d-flex align-items-center"
                        style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                        }}
                    >
                        Months
                    </div>
                </div>
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Loan Description:</label>
                <div className={`form-control justify-content-between py-1 pe-1 `}>
                    <textarea 
                        rows={3}
                        className="inputNone w-100"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>  
                <div className="d-flex align-items- justify-content-between" style={{gap: '10px'}}>
                    <div className={`myBtn w-100 text-center mt-3 bg-danger`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={DeleteLoanOffer}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Delete'}</div>
                    <div className={`myBtn w-100 text-center mt-3 bg-prime ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? EditLoanOffer : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
                </div>
            </Modal>
        </div>
    )
  }
  
  export default LoanOffer